var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"autoClose":false,"large":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Beiðnir nemanda")]),(_vm.studentId)?_c('StudentInfo',{staticStyle:{"margin-bottom":"-10px"},attrs:{"id":_vm.studentId}}):_vm._e(),_c('StudentAbsenceRequests',{attrs:{"id":_vm.studentId,"absenceTypes":_vm.absenceTypes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }